module.exports = __webpack_public_path__ + "img/add_product.d5a7046e.svg";